<template>
  <v-dialog v-model="dialog" persistent width="60%">
    <v-btn color="secondary" dark slot="activator">
      <v-icon small>$vuetify.icons.rms_create</v-icon>
      {{$t('rms.button.create')}}
    </v-btn>
    <v-card class="pa-3">
      <v-card-title primary-title>
        <div>
          <div class="title">{{$t('film.create.title')}}</div>
          <div class="py-1 body-1 greyDarken1--text">{{$t('screener.film.create.subtitle')}}</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn class="mx-0 px-0" small dark icon color="grey" @click.native="dialog = false">
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
          id="title"
          :label="$t('rms.field.title.label')"
          placeholder="My Movie"
          name="title"
          :rules="[rules.min_length(3), rules.max_length(250)]"
          counter="250"
          prepend-icon="$vuetify.icons.rms_movie"
          type="text"
          v-model="title[currentLocale]"
        >
          <v-tooltip slot="append" top color="white">
            <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
            <span class="greyDarken3--text body-1">{{$t('rms.help.text.film.input_field.title')}}</span>
          </v-tooltip>
        </v-text-field>
        <!-- <v-card elevation="2" tile class="mb-4">
          <v-card-title>
            <v-tabs
                background-color="transparent"
                color="basil"
                grow
                v-model="widget_language"
            >
              <v-tab
                v-for="language in languages" :key="language.value"
              >
                  {{ language.text }}
              </v-tab>
            </v-tabs>
          </v-card-title>
          <v-card-text>
            <v-tabs-items v-model="widget_language">
              <v-tab-item
                  v-for="language in languages"
                  :key="language.name"
              >
                <v-form onsubmit="return false;">
                  <v-text-field
                    id="title"
                    :label="$t('rms.field.title.label')"
                    placeholder="My Movie"
                    name="title"
                    :rules="[rules.min_length(3), rules.max_length(250)]"
                    counter="250"
                    prepend-icon="$vuetify.icons.rms_movie"
                    type="text"
                    v-model="title[language.value]"
                  >
                    <v-tooltip slot="append" top color="white">
                      <v-icon slot="activator">$vuetify.icons.rms_help_circle</v-icon>
                      <span class="greyDarken3--text body-1">{{$t('rms.help.text.film.input_field.title')}}</span>
                    </v-tooltip>
                  </v-text-field>
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card> -->
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          outline
          @click.native="dialog = false"
        >{{$t("reminder.dialog.box.button.close")}}</v-btn>
         <v-btn
          :loading="loading"
          color="primary"
          outline
          @click.prevent="create()"
        >{{$t("film.delivery_profile.button.create")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DEFINES from "@/defines";
import rules from "@/validation";
import { mapState, mapGetters } from "vuex";
export default {
  name: "CreateFilm",
  data() {
    return {
      rules,
      dialog: false,
      title: {
        en: '',
        es: '',
        he: '',
        ru: '',
        it: ''
      },
      right_holder_email: null,
      loading: false,
      widget_language:0,
      languages: DEFINES.LOCALES,
    };
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected"
    }),
    currentLocale() {
      return this.$i18n.locale;
    }
  },

  methods: {
    async create() {
      // if (!this.$refs.form_en.validate()) {
      //   return false;
      // }

      try {
        this.loading = true;
        var response = await this.$store.dispatch("film/create", {
          title: this.title
        });
        await this.$store.dispatch("film/list");
        this.$router.push({
          name: "Film",
          params: {
            company_id: this.selected_company_id,
            film_id: response.film.id
          }
        });
        this.$store.dispatch("app/showMessage", {
          message: "Created Successfully ",
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    }
  }
};
</script>
